class FiltroListaObjetosConId {
    equals() {}
}

export { FiltroListaObjetosConId as default };
